export enum QuestionType {
  Applicant4DigitCode = 'applicantPrimaryPhoneLast4Digits',
}
